module.exports = __webpack_public_path__ + "static/media/is.6cb860a5.svg";